export default function AnalyticsEmptyState({ title = "No analytics yet", message = "Analytics will appear here after public viewers open this page." }) {
  return (
    <div className="rounded-xl border border-dashed border-slate-300 bg-white p-8 text-center">
      <h2 className="text-lg font-semibold text-slate-950">{title}</h2>
      <p className="mx-auto mt-2 max-w-xl text-sm leading-6 text-slate-600">{message}</p>
    </div>
  );
}
